import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

export interface DeletePromotionCodeResult {
  deletePlusPromotionCodeV2:
    | {
        __typename: 'DeletePlusPromotionCodeResultV2'
        success: boolean
      }
    | {
        __typename: 'PlusPromotionCodeErrorV2'
        type: string
        error: string
      }
}

export interface DeletePromotionCodeVariables {
  id: string
}

const MUTATION = gql`
  mutation DeletePlusPromotionCode($id: String!) {
    deletePlusPromotionCodeV2(id: $id) {
      ... on DeletePlusPromotionCodeResultV2 {
        success
      }
      ... on PlusPromotionCodeErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeletePromotionCode = () => {
  return useMutation<DeletePromotionCodeResult, DeletePromotionCodeVariables>(MUTATION)
}
